import { GUIDES_AND_SURVEYS_CALLBACK_KEYS } from '../constants';

export const registerCallbackForGuideOrSurvey = async (
  key: keyof typeof GUIDES_AND_SURVEYS_CALLBACK_KEYS,
  callback: () => void,
) => {
  if (key in GUIDES_AND_SURVEYS_CALLBACK_KEYS) {
    await window?.engagement?.addCallback?.(
      GUIDES_AND_SURVEYS_CALLBACK_KEYS[key],
      callback,
    );
  } else {
    throw new Error(`Invalid guide or survey callback key: ${key}`);
  }
};
